(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ag-core"] && !Shopify.designMode) return;
  try {
    window.AG = window.AG || (function () {
    var toast;
    // fix QA 1 (30/09): los añadidos los confirma el aviso de cesta (#fstoast); este aviso queda sobre
    // todo para errores. showToast(msg, 'error') cambia la marca de «hecho» por un aviso (D32: tinta
    // con icono, sin color nuevo). role="status" para que el lector de pantalla lo anuncie.
    var ICONO_OK = '<polyline points="20 6 9 17 4 12"/>';
    var ICONO_ERROR = '<circle cx="12" cy="12" r="9"/><line x1="12" y1="7.5" x2="12" y2="13"/><line x1="12" y1="16.5" x2="12" y2="16.6"/>';
    function ensureToast() {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'ag-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        toast.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONO_OK + '</svg><span></span>';
        document.body.appendChild(toast);
      }
      return toast;
    }
    function showToast(msg, tipo) {
      var t = ensureToast();
      t.querySelector('svg').innerHTML = tipo === 'error' ? ICONO_ERROR : ICONO_OK;
      t.querySelector('span').textContent = msg;
      t.classList.add('is-show');
      clearTimeout(t._tt);
      t._tt = setTimeout(function () { t.classList.remove('is-show'); }, tipo === 'error' ? 4000 : 2400);
    }
    function refreshCount() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          // Horizon: el contador real es <cart-icon>, que escucha el evento cart:update.
          // source != 'product-form-component' => fija el total (no suma).
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ag-core', itemCount: c.item_count, cart: c } } }));
          // Fallback para otros markups/temas.
          document.querySelectorAll('[data-cart-count], .cart-count, cart-icon-component [data-count], .cart-bubble__text-count').forEach(function (el) { el.textContent = c.item_count; });
          return c;
        });
    }
    // add 2026-09-30 (Claude, ADR-013): properties opcional (p. ej. { Molido: 'Grano' }), como el formulario de la ficha
    function addToCart(variantId, qty, properties) {
      var item = { id: variantId, quantity: qty || 1 };
      if (properties && Object.keys(properties).length) item.properties = properties;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function (res) {
        return refreshCount().then(function () { return res; });
      });
    }
    return { showToast: showToast, addToCart: addToCart, refreshCount: refreshCount };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["calculadora-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; }
    function gramsOf(title) {
      var t = String(title || '').toLowerCase().replace(/\s+/g, '').replace(',', '.');
      var m = t.match(/^([\d.]+)(kg|g)$/);
      return m ? parseFloat(m[1]) * (m[2] === 'kg' ? 1000 : 1) : null;
    }
    function label(g) { return g >= 1000 ? String(g / 1000).replace('.', ',') + ' kg' : g + ' g'; }
    function fmtG(g) { return g >= 1000 ? String(Math.round(g / 10) / 100).replace('.', ',') + ' kg' : Math.round(g) + ' g'; }
    // Opciones del formulario de la ficha (p. ej. el molido del café), como la barra fija (ADR-013)
    function formProps() {
      var form = document.querySelector('.agp-form'), props = {};
      if (!form) return props;
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var k = el.name.slice(11, -1);
        if ((el.type === 'radio' || el.type === 'checkbox') ? el.checked : el.value) props[k] = el.value;
      });
      return props;
    }

    document.querySelectorAll('[data-agcalc]').forEach(function (root) {
      var ration = parseFloat(root.dataset.ration) || 0;
      var unit = root.dataset.unit || 'ración', units = root.dataset.units || 'raciones';
      var variants = [];
      try { variants = JSON.parse(root.querySelector('[data-agcalc-variants]').textContent); } catch (e) {}
      var fmts = variants.map(function (v) { v.grams = gramsOf(v.title); return v; })
        .filter(function (v) { return v.grams && v.available; })
        .sort(function (a, b) { return a.grams - b.grams; });
      var servings = root.querySelector('[data-agcalc-servings]');
      var gramsEl = root.querySelector('[data-agcalc-grams]');
      var formatEl = root.querySelector('[data-agcalc-format]');
      var addBtn = root.querySelector('[data-agcalc-add]');
      var pick = [];

      function recomendar(needed) {
        if (!fmts.length) return [];
        var max = fmts[fmts.length - 1];
        if (needed <= max.grams) {
          for (var i = 0; i < fmts.length; i++) if (fmts[i].grams >= needed) return [{ v: fmts[i], q: 1 }];
        }
        var n = Math.floor(needed / max.grams), resto = needed - n * max.grams, out = [{ v: max, q: n }];
        if (resto > 0) {
          var r = null;
          for (var j = 0; j < fmts.length; j++) if (fmts[j].grams >= resto) { r = fmts[j]; break; }
          if (r === max) out[0].q += 1; else if (r) out.push({ v: r, q: 1 });
        }
        return out;
      }
      function texto(sel) {
        return sel.map(function (s) { return (s.q > 1 ? s.q + ' × ' : '') + label(s.v.grams); }).join(' + ');
      }
      function update() {
        var s = Math.min(99, Math.max(1, parseInt(servings.value, 10) || 1));
        var needed = ration * s;
        gramsEl.textContent = fmtG(needed);
        pick = recomendar(needed);
        if (!pick.length) { formatEl.textContent = ''; addBtn.hidden = true; return; }
        var total = pick.reduce(function (a, p) { return a + p.v.price * p.q; }, 0);
        var t = texto(pick);
        formatEl.innerHTML = '';
        formatEl.append((pick.length === 1 && pick[0].q === 1 ? 'Formato recomendado: ' : 'Te recomendamos: '));
        var b = document.createElement('b'); b.textContent = t; formatEl.append(b, ' · ' + euros(total));
        addBtn.hidden = false;
        addBtn.classList.remove('is-added');
        addBtn.textContent = 'Añadir ' + t;
        addBtn.setAttribute('aria-label', 'Añadir a la cesta: ' + t + ', ' + euros(total));
      }
      function step(d) { servings.value = Math.min(99, Math.max(1, (parseInt(servings.value, 10) || 1) + d)); update(); }
      root.querySelector('[data-agcalc-minus]').addEventListener('click', function () { step(-1); });
      root.querySelector('[data-agcalc-plus]').addEventListener('click', function () { step(1); });
      servings.addEventListener('input', update);
      servings.addEventListener('change', function () { step(0); });

      addBtn.addEventListener('click', function () {
        if (!pick.length || addBtn.disabled) return;
        var props = formProps(), t = texto(pick);
        var items = pick.map(function (p) {
          var it = { id: p.v.id, quantity: p.q };
          if (Object.keys(props).length) it.properties = props;
          return it;
        });
        addBtn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); })
          .then(function () {
            if (window.AG && AG.refreshCount) AG.refreshCount();
            addBtn.classList.add('is-added');
            addBtn.textContent = '✓ Añadido';
            // fix QA 1: sin aviso propio; el aviso de cesta (#fstoast) ya confirma. El toast queda para errores.
            setTimeout(update, 1800);
          })
          .catch(function (e) { if (window.AG) AG.showToast((e && e.description) || 'No se pudo añadir a la cesta', 'error'); })
          .then(function () { addBtn.disabled = false; });
      });
      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cross-sell-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    /* --- añadir a la cesta (compartido con v1) --- */
    function post(items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) { j = j || {}; if (!j.status) j.status = r.status; throw j; }
            return j;
          });
        });
    }
    function itemDe(b) { return { id: parseInt(b.dataset.agxAdd, 10), quantity: parseInt(b.dataset.qty, 10) || 1 }; }
    function nombreDe(row) { var a = row && row.querySelector('.gram-row__name'); return a ? a.textContent.replace(/\s+/g, ' ').trim() : ''; }
    function esAgotado(e) { return !!e && String(e.status) === '422'; }
    function avisarCambio(desde) { desde.dispatchEvent(new CustomEvent('agx:cambio', { bubbles: true })); }

    /* Agotados (26/10): una fila que Shopify rechaza (422, «ya está agotado») pasa a «Agotado», como
       las que ya lo estaban al pintar la página (el HTML puede venir de caché). */
    function marcarAgotada(b) {
      var row = b.closest('.gram-row');
      if (!row) return;
      row.classList.add('gram-row--agotado');
      row.setAttribute('data-agotado', '');
      var precio = row.querySelector('[data-gram-price]');
      if (precio) { precio.removeAttribute('data-gram-price'); precio.className = 'gram-row__agotado'; precio.textContent = 'Agotado'; }
      b.removeAttribute('data-agx-add');
      b.disabled = true;
      b.setAttribute('aria-label', (b.dataset.name || nombreDe(row)) + ': agotado ahora');
    }

    /* Añade en una sola llamada las filas a la venta de un módulo GRAMAJE. Si Shopify rechaza el lote
       entero (un ingrediente se agotó después de pintar la página), las prueba una a una: entran las
       que se pueden y las agotadas quedan marcadas. La usa también «Añadir los ingredientes» de
       sections/main-blog-post.liquid. Devuelve { ok, ko, koNombres, msg }. */
    function anadirFilas(scope) {
      var btns = [].slice.call(scope.querySelectorAll('[data-agx-add]'));
      var res = { ok: [], ko: [], koNombres: [], msg: '' };
      if (!btns.length) return Promise.resolve(res);
      return post(btns.map(itemDe)).then(function () {
        res.ok = btns;
      }, function (err) {
        res.msg = (err && err.description) || '';
        return btns.reduce(function (cadena, b) {
          return cadena.then(function () {
            return post([itemDe(b)]).then(function () { res.ok.push(b); }, function (e) {
              res.ko.push(b);
              if (e && e.description) res.msg = e.description;
              if (esAgotado(e)) { res.koNombres.push(b.dataset.name || nombreDe(b.closest('.gram-row'))); marcarAgotada(b); }
            });
          });
        }, Promise.resolve());
      }).then(function () {
        res.ok.forEach(function (b) { b.classList.add('is-added'); b.textContent = '✓'; });
        if (res.ok.length && window.AG) AG.refreshCount(); /* fix QA 1: confirma el aviso de cesta («Añadido: N productos») */
        if (res.koNombres.length) avisarCambio(res.ko[0]);
        return res;
      });
    }
    window.AGX = window.AGX || {};
    window.AGX.anadirFilas = anadirFilas;

    if (!window.__agxBound) {
      window.__agxBound = true;
      document.addEventListener('click', function (e) {
        var one = e.target.closest('[data-agx-add]');
        var all = e.target.closest('[data-agx-all]');
        if (one) {
          e.preventDefault();
          AG.addToCart(one.dataset.agxAdd, parseInt(one.dataset.qty, 10) || 1).then(function () {
            one.classList.add('is-added');
            one.textContent = '✓';
            /* fix QA 1: sin aviso propio; confirma el aviso de cesta. El toast queda para errores. */
          }).catch(function (err) {
            /* Agotados: la fila queda marcada y el aviso es el de Shopify («… ya está agotado») */
            if (esAgotado(err)) { marcarAgotada(one); avisarCambio(one); }
            AG.showToast((err && err.description) || 'No se pudo añadir', 'error');
          });
        }
        if (all) {
          e.preventDefault();
          if (all.disabled || all.getAttribute('aria-busy') === 'true') return;
          /* en el GRAMAJE, cada fila lleva sus unidades en data-qty */
          var scope = all.closest('[data-gram]');
          if (!scope) {
            var ids = (all.dataset.agxAll || '').split(',').filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
            if (!ids.length) return;
            post(ids).then(function () { AG.refreshCount(); }).catch(function (err) { AG.showToast((err && err.description) || 'No se pudo añadir', 'error'); });
            return;
          }
          all.setAttribute('aria-busy', 'true');
          anadirFilas(scope).then(function (res) {
            if (!res.ok.length) AG.showToast(res.msg || 'No se pudo añadir', 'error');
            else if (res.koNombres.length) AG.showToast((res.ok.length === 1 ? '1 ingrediente añadido' : res.ok.length + ' ingredientes añadidos') + '. Agotado ahora: ' + res.koNombres.join(', '));
          }).catch(function () { AG.showToast('No se pudo añadir', 'error'); })
            .then(function () { all.removeAttribute('aria-busy'); });
        }
      });
    }

    /* --- GRAMAJE: escalado de raciones ---
       Misma regla que el planificador: unidades de la variante base que cubren los gramos. */
    /* fix QA 1: formato español fijo, igual que el Liquid (money_without_currency + « €») y que
       euros() de la calculadora: «6,08 €». No depende de shop.money_format (hoy «€6,08», D26). */
    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }
    function setupGram(root) {
      var base = parseInt(root.dataset.base, 10) || 2;
      var hasG = root.dataset.hasG === 'true';
      var max = Math.max(12, base * 2);
      var rac = base;
      var racEl = root.querySelector('[data-gram-rac]');
      var totalEl = root.querySelector('[data-gram-total]');
      var rows = [].slice.call(root.querySelectorAll('.gram-row'));
      function render() {
        if (racEl) racEl.textContent = rac;
        var total = 0;
        rows.forEach(function (row) {
          var g0 = parseFloat(row.dataset.g) || 0;
          var price = parseFloat(row.dataset.price) || 0;    // céntimos de una unidad de la variante base
          var unitG = parseFloat(row.dataset.unitG) || 100;  // gramos de esa unidad
          var units = 1;
          if (hasG && g0 > 0) {
            var g = Math.max(1, Math.round(g0 * rac / base));
            units = Math.max(1, Math.ceil(g / unitG));
            var buy = units * unitG;
            var gEl = row.querySelector('[data-gram-g]');
            if (gEl) gEl.textContent = g + ' g en la receta' + (buy !== g ? ' · se añaden ' + buy + ' g' : '');
          }
          if (row.hasAttribute('data-agotado')) return; /* agotados: ni precio ni total */
          var add = row.querySelector('[data-agx-add]');
          if (add) add.dataset.qty = units;
          var pEl = row.querySelector('[data-gram-price]');
          if (pEl) pEl.textContent = money(units * price);
          total += units * price;
        });
        if (totalEl) totalEl.textContent = money(total);
      }
      /* Agotados: el pie cuenta solo lo disponible (mismos textos que el Liquid) */
      function pie() {
        var all = root.querySelector('[data-agx-all]');
        var n = root.querySelectorAll('[data-agx-add]').length;
        var ko = [].slice.call(root.querySelectorAll('.gram-row[data-agotado]')).map(nombreDe).filter(Boolean);
        if (!all || !ko.length) return;
        all.disabled = n === 0;
        all.textContent = n === 0 ? (ko.length === 1 ? 'Agotado ahora' : 'Agotados ahora') : 'Añadir los disponibles (' + n + ')';
        var aviso = root.querySelector('[data-gram-agotados]');
        if (!aviso) {
          aviso = document.createElement('p');
          aviso.className = 'gram__agotados';
          aviso.setAttribute('data-gram-agotados', '');
          all.insertAdjacentElement('afterend', aviso);
        }
        aviso.textContent = (ko.length === 1 ? '1 ingrediente agotado ahora: ' : ko.length + ' ingredientes agotados ahora: ') + ko.join(', ') + '.';
      }
      root.addEventListener('agx:cambio', function () { render(); pie(); });
      var inc = root.querySelector('[data-gram-inc]');
      var dec = root.querySelector('[data-gram-dec]');
      if (inc) inc.addEventListener('click', function () { rac = Math.min(max, rac + 1); render(); });
      if (dec) dec.addEventListener('click', function () { rac = Math.max(1, rac - 1); render(); });
      render();
    }
    function init() { document.querySelectorAll('[data-gram]').forEach(setupGram); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__agfsBound) return;
    window.__agfsBound = true;

    function render(el, total, items) {
      var E = window.agEnvio;
      if (!E) return;
      var th = parseInt(el.dataset.threshold, 10) || E.UMBRAL;
      var e = E.estado(total, items);
      var fill = el.querySelector('[data-agfs-fill]');
      var label = el.querySelector('[data-agfs-text]');
      var antes = null;
      ['vacia', 'minimo', 'envio', 'gratis'].forEach(function (k) { if (el.classList.contains('agfs--' + k)) antes = k; });
      if (antes !== e) {
        ['vacia', 'minimo', 'envio', 'gratis'].forEach(function (k) { el.classList.toggle('agfs--' + k, k === e); });
        el.classList.toggle('agfs--free', e === 'gratis');
      }
      if (fill) fill.style.width = Math.max(0, Math.min(100, th > 0 ? (total / th * 100) : 0)) + '%';
      // Ronda 1 de QA: si el estado no cambia, solo el importe (ver agEnvio.pintarFrase).
      if (label) { if (E.pintarFrase) E.pintarFrase(label, antes, total, items); else label.innerHTML = E.html(total, items); }
    }

    function refresh(event) {
      var d = event && event.detail;
      var updatedCart = d && d.data && d.data.cart;
      if (updatedCart && Number.isFinite(updatedCart.total_price)) {
        document.querySelectorAll('[data-agfs]').forEach(function (el) { render(el, updatedCart.total_price, updatedCart.item_count); });
        return;
      }
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-agfs]').forEach(function (el) { render(el, cart.total_price, cart.item_count); });
        })
        .catch(function () {});
    }

    // Horizon dispara 'cart:update' al añadir o cambiar la cesta; los códigos de descuento, 'discount:update'.
    document.addEventListener('cart:update', refresh);
    document.addEventListener('discount:update', refresh);
    // Hook para la cantidad optimista (ag-cart-keep-open.js): pinta sin pedir /cart.js.
    window.agfsRender = function (total, items) {
      document.querySelectorAll('[data-agfs]').forEach(function (el) { render(el, total, items); });
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__agqaBound) return;
    window.__agqaBound = true;

    var CHECK = '<svg class="ag-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';
    var E = {}; // estado por producto: { key, qty, formato, objetivo, enVuelo, lineas, variantes, total }

    function st(pid) { return E[pid] || (E[pid] = { key: null, qty: 0, formato: '', objetivo: null, enVuelo: false, lineas: 0, variantes: 0, total: 0, vids: [] }); }

    // Cuenta las líneas del producto en la cesta (QA-2 n.º 8). Con una sola, esa línea manda el contador.
    function contar(s, pid, items) {
      var lineas = (items || []).filter(function (it) { return String(it.product_id) === String(pid); });
      var vs = {};
      s.lineas = lineas.length;
      s.total = 0;
      lineas.forEach(function (it) { vs[it.variant_id] = 1; s.total += it.quantity; });
      s.variantes = Object.keys(vs).length;
      s.vids = Object.keys(vs);
      var it = null;
      for (var i = 0; i < lineas.length; i++) { if (lineas[i].key === s.key) { it = lineas[i]; break; } }
      if (!it) it = lineas[0] || null;
      if (it) { s.key = it.key; s.qty = it.quantity; s.formato = formato(it.variant_title); }
      else { s.key = null; s.qty = 0; }
    }

    function textoVarias(s) {
      return s.variantes > 1 ? s.variantes + ' formatos en tu cesta' : s.total + ' en tu cesta';
    }
    function todas(pid) { return document.querySelectorAll('[data-agqa][data-product-id="' + pid + '"]'); }
    function tarjeta(q) { return q.closest('.pd__card, product-card, .product-card') || q.parentElement; }

    // Anuncio para lectores de pantalla (un único aviso, sin toast visual: la tarjeta ya lo dice)
    var vivo;
    function anunciar(msg) {
      if (!vivo) {
        vivo = document.createElement('div');
        vivo.className = 'visually-hidden';
        vivo.setAttribute('role', 'status');
        vivo.setAttribute('aria-live', 'polite');
        document.body.appendChild(vivo);
      }
      vivo.textContent = '';
      setTimeout(function () { vivo.textContent = msg; }, 30);
    }

    // «100g» → «100 g», igual que ag-precio-unidad.liquid con formato: true (dueña: zona ficha)
    function formato(t) {
      t = String(t || '').trim();
      if (!t || t === 'Default Title') return '';
      var m = t.replace(/\s+/g, '').match(/^([\d.,]+)(kg|ml|cl|g|l)$/i);
      return m ? m[1].replace('.', ',') + ' ' + m[2].toLowerCase() : t;
    }

    function etiqueta(q) {
      var c = tarjeta(q);
      var f = c.querySelector('[data-agqa-flag]');
      if (f) return f;
      var host = c.querySelector('.pd__img-wrap, .card-gallery, .product-media-container');
      if (!host) return null;
      f = document.createElement('span');
      f.className = 'pd__encesta';
      f.setAttribute('data-agqa-flag', '');
      f.hidden = true;
      f.innerHTML = CHECK + '<span data-agqa-flag-txt></span>';
      host.appendChild(f);
      return f;
    }

    // Coste de DOM (02/10, coste-dom/ESPEC-COSTE.md, medida A): pintar() corre al cargar sobre todas las
    // tarjetas (leerDom, el primer MutationObserver y sincronizar tras /cart.js) y solo debe tocar el DOM si
    // algo cambia. Reescribir el mismo texto o el mismo atributo invalidaba estilo y maquetación de toda la
    // rejilla tres veces por carga (traza C13 S05: Layout de 287 objetos de 12,4 y 14,0 ms y recálculos de
    // 571 elementos; la pila de InvalidateLayout apunta a pintar). Con la cesta vacía, ahora no escribe nada.
    function ponTxt(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
    function ponAttr(el, nombre, valor) { if (el && valor != null && el.getAttribute(nombre) !== valor) el.setAttribute(nombre, valor); }
    function ponOculto(el, oculto) { if (el && el.hidden !== oculto) el.hidden = oculto; }
    function ponClase(el, clase, si) { if (el && el.classList.contains(clase) !== si) el.classList.toggle(clase, si); }

    function pintar(q, n, fmt, s) {
      var add = q.querySelector('.agqa__add');
      var inc = q.querySelector('[data-agqa-incart]');
      var flag = tarjeta(q).querySelector('[data-agqa-flag]');
      var multi = !!(s && s.lineas > 1 && s.objetivo == null);
      if (!flag && (n > 0 || multi)) flag = etiqueta(q);
      if (!add || !inc) return;
      var tg = q.querySelector('[data-agqa-toggle]');
      var tgTxt = tg && tg.querySelector('[data-agqa-btn-txt]');
      if (tg) ponAttr(tg, 'aria-label', tg.getAttribute(multi ? 'data-label-otro' : 'data-label-anadir') || tg.getAttribute('aria-label'));
      ponTxt(tgTxt, multi ? 'Otro formato' : 'Añadir');
      ponClase(q, 'is-multi', multi);
      // En el selector, los formatos que ya están en la cesta llevan una marca (y lo dicen al lector)
      var vids = (s && s.vids) || [];
      q.querySelectorAll('.agqa__opt[data-agqa-variant]').forEach(function (o) {
        var dentro = vids.indexOf(String(o.getAttribute('data-agqa-variant'))) > -1;
        ponClase(o, 'is-encesta', dentro);
        var ok = o.querySelector('.agqa__opt-ok');
        if (dentro && !ok) { ok = document.createElement('span'); ok.className = 'agqa__opt-ok'; ok.innerHTML = CHECK; o.querySelector('.agqa__opt-f').prepend(ok); }
        if (!dentro && ok) ok.remove();
        var base = o.getAttribute('data-label');
        if (base) ponAttr(o, 'aria-label', dentro ? base + '. Ya tienes este formato en tu cesta' : base);
      });
      if (multi) {
        // Varias líneas: se dice cuántas y se deja elegir otro formato; el contador no, porque no sabría cuál cambiar
        ponClase(q, 'is-incart', true);
        ponOculto(add, false);
        ponOculto(inc, true);
        if (flag) {
          ponOculto(flag, false);
          ponTxt(flag.querySelector('[data-agqa-flag-txt]'), textoVarias(s));
        }
      } else if (n > 0) {
        ponClase(q, 'is-incart', true);
        ponOculto(add, true);
        ponOculto(inc, false);
        ponTxt(q.querySelector('[data-agqa-qty]'), String(n));
        ponAttr(q.querySelector('[data-agqa-dec]'), 'aria-label', n > 1 ? 'Quitar una unidad' : 'Quitar de la cesta');
        if (flag) {
          ponOculto(flag, false);
          ponTxt(flag.querySelector('[data-agqa-flag-txt]'), (fmt ? fmt + ' ' : '') + 'en tu cesta');
        }
      } else {
        ponClase(q, 'is-incart', false);
        ponOculto(add, false);
        ponOculto(inc, true);
        if (flag) ponOculto(flag, true);
      }
    }

    function pintarPid(pid) {
      var s = st(pid);
      var n = s.objetivo != null ? s.objetivo : s.qty;
      todas(pid).forEach(function (q) { pintar(q, n, s.formato, s); });
    }

    // Estado que viene del servidor
    function leerDom(raiz) {
      (raiz || document).querySelectorAll('[data-agqa]').forEach(function (q) {
        var pid = q.getAttribute('data-product-id');
        if (!pid || E[pid]) return;
        var s = st(pid);
        if (q.getAttribute('data-key')) {
          s.key = q.getAttribute('data-key');
          s.qty = parseInt(q.getAttribute('data-qty'), 10) || 0;
          s.formato = q.getAttribute('data-formato') || '';
          s.lineas = parseInt(q.getAttribute('data-lineas'), 10) || 1;
          s.variantes = parseInt(q.getAttribute('data-variantes'), 10) || 1;
          s.vids = (q.getAttribute('data-vids') || '').split(',').filter(Boolean);
          s.total = s.qty;
        }
        pintar(q, s.qty, s.formato, s);
        q.__agqaPintada = true; // coste de DOM (A): el primer MutationObserver no vuelve a pintar las 36 tarjetas
      });
    }

    function sincronizar(cart) {
      if (!cart || !cart.items) return;
      document.querySelectorAll('[data-agqa]').forEach(function (q) {
        var pid = q.getAttribute('data-product-id');
        var s = st(pid);
        if (s.enVuelo || s.objetivo != null) return;
        contar(s, pid, cart.items);
        pintar(q, s.qty, s.formato, s);
      });
    }

    var marcaPropia = 0;
    function avisarCesta(cart) {
      marcaPropia = Date.now();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'ag-core', itemCount: cart.item_count, cart: cart, agqa: true } } }));
      document.querySelectorAll('[data-cart-count], .cart-count, cart-icon-component [data-count], .cart-bubble__text-count').forEach(function (el) { el.textContent = cart.item_count; });
    }

    function leerCesta() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { sincronizar(c); return c; });
    }

    function cerrarTodo(except) {
      document.querySelectorAll('[data-agqa-pop]').forEach(function (p) {
        if (p === except || p.hidden) return;
        p.hidden = true;
        var t = p.parentElement.querySelector('[data-agqa-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    // Café: la propiedad de línea «Molido» con el valor del selector (los mismos que la ficha)
    var MOLIDO_TXT = { 'Grano': 'en grano', 'Molido cafetera expreso': 'molido para cafetera expreso', 'Molido cafetera italiana': 'molido para cafetera italiana', 'Molido cafetera americana (filtro de papel)': 'molido para cafetera americana' };
    function propiedades(q) {
      var sel = q.querySelector('[data-agqa-molido]');
      return sel ? { Molido: sel.value || 'Grano' } : null;
    }

    function anadir(q, variantId, fmt, origen) {
      var pid = q.getAttribute('data-product-id');
      var s = st(pid);
      if (origen.classList.contains('is-loading')) return;
      origen.classList.add('is-loading');
      origen.setAttribute('aria-busy', 'true');
      var props = propiedades(q);
      var claveAntes = s.key, habia = s.lineas || (s.qty > 0 ? 1 : 0);
      AG.addToCart(variantId, 1, props).then(function (res) {
        var it = res && res.items && res.items[0];
        s.key = it ? it.key : s.key;
        s.qty = it ? it.quantity : s.qty + 1;
        s.formato = fmt;
        if (s.vids.indexOf(String(variantId)) < 0) s.vids.push(String(variantId));
        // ¿Otra línea del mismo producto (otro formato u otro molido)? Entonces ya son varias (QA-2 n.º 8)
        if (habia > 0 && it && it.key !== claveAntes) {
          s.lineas = Math.max(habia + 1, s.lineas + 1);
          s.variantes = Math.max(s.variantes || 1, 2);
          s.total = (s.total || 0) + 1;
        } else if (habia === 0) {
          s.lineas = 1; s.variantes = 1; s.total = s.qty;
        } else {
          s.total = (s.total || 0) + 1;
        }
        cerrarTodo(null);
        pintarPid(pid);
        marcaPropia = Date.now(); // AG.addToCart ya avisa a la cabecera con cart:update
        if (s.lineas > 1) leerCesta().catch(function () {}); // recuento exacto de líneas y formatos
        anunciar('Añadido: ' + (fmt ? fmt + ' de ' : '') + q.getAttribute('data-name') + (props ? ', ' + (MOLIDO_TXT[props.Molido] || props.Molido) : '') + '. ' + (s.lineas > 1 ? textoVarias(s) : s.qty + ' en tu cesta') + '.');
        var mas = s.lineas > 1 ? q.querySelector('[data-agqa-toggle]') : q.querySelector('[data-agqa-inc]');
        if (mas && document.activeElement && (document.activeElement === origen || document.activeElement === document.body || q.contains(document.activeElement))) mas.focus({ preventScroll: true });
      }).catch(function (e) {
        AG.showToast((e && e.description) ? e.description : 'No se pudo añadir. Inténtalo de nuevo.');
      }).then(function () {
        origen.classList.remove('is-loading');
        origen.removeAttribute('aria-busy');
      });
    }

    function enviar(pid) {
      var s = st(pid);
      if (s.enVuelo || s.objetivo == null || !s.key) return;
      var objetivo = s.objetivo;
      var previo = s.qty;
      s.enVuelo = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: s.key, quantity: objetivo })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function (cart) {
        s.enVuelo = false;
        if (s.objetivo !== objetivo) { enviar(pid); return; } // el cliente siguió tocando: manda lo último
        s.objetivo = null;
        contar(s, pid, cart.items);
        pintarPid(pid);
        avisarCesta(cart);
        anunciar(s.qty > 0 ? s.qty + ' en tu cesta.' : 'Quitado de la cesta.');
      }).catch(function (e) {
        s.enVuelo = false;
        s.objetivo = null;
        s.qty = previo;
        pintarPid(pid);
        AG.showToast((e && e.description) ? e.description : 'No se pudo cambiar la cantidad.');
      });
    }

    function cambiar(q, delta) {
      var pid = q.getAttribute('data-product-id');
      var s = st(pid);
      if (!s.key) return;
      var base = s.objetivo != null ? s.objetivo : s.qty;
      var nueva = Math.max(0, base + delta);
      if (nueva === base) return;
      s.objetivo = nueva;
      pintarPid(pid); // optimista: el número cambia ya
      if (nueva === 0) {
        var t = q.querySelector('[data-agqa-toggle], [data-agqa-direct]');
        if (t) t.focus({ preventScroll: true });
      }
      enviar(pid);
    }

    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-agqa]');
      var toggle = e.target.closest('[data-agqa-toggle]');
      var direct = e.target.closest('[data-agqa-direct]');
      var opt = e.target.closest('.agqa__opt');
      var dec = e.target.closest('[data-agqa-dec]');
      var inc = e.target.closest('[data-agqa-inc]');

      if (toggle && q) {
        e.preventDefault();
        var pop = q.querySelector('[data-agqa-pop]');
        var abrir = pop.hidden;
        cerrarTodo(abrir ? pop : null);
        pop.hidden = !abrir;
        toggle.setAttribute('aria-expanded', String(abrir));
        if (abrir) { var primera = pop.querySelector('[data-agqa-molido], .agqa__opt:not([disabled])'); if (primera) primera.focus({ preventScroll: true }); }
        return;
      }
      if (opt && q) {
        e.preventDefault();
        if (opt.disabled) return;
        anadir(q, opt.getAttribute('data-agqa-variant'), opt.getAttribute('data-formato') || '', opt);
        return;
      }
      if (direct && q) {
        e.preventDefault();
        if (direct.disabled) return;
        anadir(q, direct.getAttribute('data-agqa-variant'), direct.getAttribute('data-formato') || '', direct);
        return;
      }
      if (dec && q) { e.preventDefault(); cambiar(q, -1); return; }
      if (inc && q) { e.preventDefault(); cambiar(q, 1); return; }
      if (!e.target.closest('[data-agqa-pop]')) cerrarTodo(null);
    });

    // Esc cierra el selector y devuelve el foco a «Añadir»
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var pop = e.target.closest && e.target.closest('[data-agqa-pop]');
      if (!pop || pop.hidden) return;
      pop.hidden = true;
      var t = pop.parentElement.querySelector('[data-agqa-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });

    // Otras partes de la tienda cambian la cesta (ficha, cajón, /cart): se sincroniza
    var espera;
    document.addEventListener('cart:update', function (ev) {
      var d = ev && ev.detail && ev.detail.data;
      if (d && d.agqa) return;
      if (d && d.cart && d.cart.items) { sincronizar(d.cart); return; }
      if (Date.now() - marcaPropia < 800) return;
      clearTimeout(espera);
      espera = setTimeout(function () { leerCesta().catch(function () {}); }, 250);
    });

    // Tarjetas que llegan después (filtros, paginación, recomendaciones)
    function alCargar() {
      leerDom();
      if (!document.querySelector('[data-agqa]')) return;
      var leer = function () { leerCesta().catch(function () {}); };
      if ('requestIdleCallback' in window) requestIdleCallback(leer, { timeout: 3000 }); else setTimeout(leer, 1500);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alCargar); else alCargar();
    if ('MutationObserver' in window) {
      var pendiente = false;
      new MutationObserver(function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var nuevas = false;
          document.querySelectorAll('[data-agqa]').forEach(function (q) {
            var pid = q.getAttribute('data-product-id');
            if (!E[pid]) { nuevas = true; return; }
            if (!q.__agqaPintada) { q.__agqaPintada = true; var s = st(pid); pintar(q, s.objetivo != null ? s.objetivo : s.qty, s.formato, s); }
          });
          if (nuevas) leerDom();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Volver con «atrás» (página restaurada de la caché): la cesta pudo cambiar
    window.addEventListener('pageshow', function (e) { if (e.persisted) leerCesta().catch(function () {}); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-add-granel"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-agsticky]');
    if (!bar) return;
    bar.hidden = false;

    var sel = bar.querySelector('[data-agsticky-sel]');
    var priceEl = bar.querySelector('[data-agsticky-price]');
    var addBtn = bar.querySelector('[data-agsticky-add]');

    if (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        addBtn.dataset.variant = sel.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        // Formato elegido en la barra -> la ficha lo sigue (precio, €/kg y botón)
        var b = document.querySelector('.agp-format[data-agp-variant="' + sel.value + '"]');
        if (b && !b.classList.contains('agp-format--active') && !bar._sync) { bar._sync = true; b.click(); bar._sync = false; }
      });
    }

    // fix 2026-09-30 (Claude, ADR-013): la barra añade lo elegido en la ficha. Antes añadía el café
    // sin «Molido» (propiedad de línea del formulario principal) y con el formato de la carga.
    var form = document.querySelector('.agp-form');
    var propEl = bar.querySelector('[data-agsticky-prop]');

    function leerPropiedades() {
      var props = {}, grupos = {}, falta = null;
      if (!form) return { props: props, falta: falta };
      form.querySelectorAll('[name^="properties["]').forEach(function (el) {
        var k = el.name.slice(11, -1);
        if (el.type === 'radio' || el.type === 'checkbox') {
          if (!grupos[k]) grupos[k] = el;
          if (el.checked) props[k] = el.value;
        } else if (el.value) { props[k] = el.value; }
      });
      Object.keys(grupos).forEach(function (k) {
        if (!falta && grupos[k].type === 'radio' && !(k in props)) falta = grupos[k];
      });
      return { props: props, falta: falta };
    }
    function nombreElegido() {
      var r = form && form.querySelector('input[type="radio"][name^="properties["]:checked');
      if (!r) return '';
      var n = r.closest('label') && r.closest('label').querySelector('.agp-grind-opt__name');
      return n ? n.textContent.trim() : r.value;
    }
    function pintarPropiedad() {
      if (!propEl) return;
      var n = nombreElegido();
      propEl.textContent = n ? '· ' + n : '';
      propEl.hidden = !n;
    }
    if (form) {
      form.addEventListener('change', pintarPropiedad);
      // Formato elegido en la ficha -> la barra lo sigue
      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-agp-variant]');
        if (!b || !sel || b.classList.contains('agp-format--soldout') || bar._sync) return;
        bar._sync = true;
        sel.value = b.getAttribute('data-agp-variant');
        sel.dispatchEvent(new Event('change'));
        bar._sync = false;
      });
    }
    pintarPropiedad();

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || document.querySelector('[data-agp-zona-bloqueada]')) return;
      var p = leerPropiedades();
      if (p.falta) {
        // Sin elección: lleva al selector en vez de añadir
        var zona = p.falta.closest('.agp-option') || p.falta;
        zona.scrollIntoView({ block: 'center' });
        p.falta.focus({ preventScroll: true });
        AG.showToast(p.falta.name === 'properties[Molido]' ? 'Elige el molido antes de añadir' : 'Elige una opción antes de añadir', 'error');
        return;
      }
      // fix QA 1: sin aviso propio al añadir bien; confirma el aviso de cesta (#fstoast), que sale con
      // el cart:update de AG.refreshCount. El toast queda solo para errores.
      AG.addToCart(addBtn.dataset.variant, 1, p.props).catch(function () { AG.showToast('No se pudo añadir a la cesta', 'error'); });
    });

    // Mostrar la barra cuando el botón principal sale de pantalla
    var anchor = document.querySelector('[data-ag-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-visible', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -10px 0px' });
      io.observe(anchor);
    } else {
      // Sin ancla: mostrar tras hacer scroll un poco
      window.addEventListener('scroll', function () {
        bar.classList.toggle('is-visible', window.scrollY > 400);
      }, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
